import { AbpApplicationConfigurationService, ApplicationConfigurationDto, ApplicationConfigurationRequestOptions } from '@abp/ng.core';
import { inject, Injectable } from '@angular/core';
import { from, map, Observable, switchMap, tap } from 'rxjs';
import { LocalConfigurationRepository } from '../local-db/repositories/local-configuration.repository';
import { ConnectionService } from './connection.service';
import { LocalConfigurationType } from '../entities/local-configuration';

@Injectable({
  providedIn: 'root',
})
export class CustomApplicationConfigurationService {
  private readonly _abpApplicationConfigurationService: AbpApplicationConfigurationService;
  private readonly _localConfigurationRepository: LocalConfigurationRepository;
  private readonly serviceProxy: ConnectionService;

  constructor() {
    this._abpApplicationConfigurationService = new AbpApplicationConfigurationService();

    this._localConfigurationRepository = inject(LocalConfigurationRepository)
    this.serviceProxy = inject(ConnectionService);
  }

  get: (options: ApplicationConfigurationRequestOptions) => Observable<ApplicationConfigurationDto> = options => {
    const instance = this as CustomApplicationConfigurationService;
    const userFromLocalStorage = localStorage.getItem(LocalStorageConsts.CurrentUserKey);
    const user = userFromLocalStorage ? JSON.parse(userFromLocalStorage) : undefined;

    return instance.serviceProxy.checkOnce().pipe(
      switchMap(isOnline => {
        if (isOnline) {
          return instance._abpApplicationConfigurationService.get(options).pipe(
            tap(response => {
              instance._localConfigurationRepository.set(
                response?.currentUser?.id ?? '',
                LocalConfigurationType.ApplicationConfiguration,
                response,
              );

              if (this.emptyString(response?.currentUser?.id)) {
                localStorage.removeItem(LocalStorageConsts.CurrentUserKey);
              } else {
                localStorage.setItem(LocalStorageConsts.CurrentUserKey, JSON.stringify(response.currentUser));
              }
            }),
          );
        } else {
          let value = from(
            instance._localConfigurationRepository.get(user?.id ?? '', LocalConfigurationType.ApplicationConfiguration),
          ).pipe(map(resp => {
            console.log(resp);
            return resp.data as ApplicationConfigurationDto;

          }));

          return value;
        }
      })
    );
  };

  emptyString(value: string | undefined): boolean {
    return (
      value === undefined || value === null || value === '' || value.toString().trim().length === 0
    );
  }
}

export class LocalStorageConsts {
  public static readonly CurrentUserKey = 'currentUser';
  public static readonly AccessTokenKey = 'access_token';
  public static readonly RefreshTokenKey = 'refresh_token';
  public static readonly HealthCheckKey = 'last_healthcheck';
}